import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from '../../../../components/hint';
import { Theme } from '../../../../theme';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';
import { AutoBreakDeductionStatus } from './shared';

type Props = {
  status: AutoBreakDeductionStatus;
  id?: string;
};

export const BreakDeductionStatusIndicator: React.FC<
  React.PropsWithChildren<Props>
> = ({ status, id = 'deduction-success' }) => {
  const { t } = useTranslation();

  if (status !== 'success') {
    return null;
  }

  return (
    <Hint
      containerClassName="d-flex align-items-center"
      id={id}
      text={t('autoBreaks.hintDeductionSuccess')}>
      <FlairIcon
        icon="remove-square-outline"
        className="ms-2"
        color={Theme.color.success}
      />
    </Hint>
  );
};
